(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chat-widget"] && !Shopify.designMode) return;
  try {
    /* Two belts, because the first one leans on a variable name that belongs to
     Shopify and can be renamed under us:

     1. we hand the widget our clearance through its own offset variable, on the
        host above and from a stylesheet injected into its shadow root here.
        Document stylesheets do not cross a shadow boundary, so everything
        inside merely inherits the host value, and that falls apart the moment
        the chat is opened: it swaps the activator for a <shopify-agent-runtime>
        carrying inline copies of the variables, and inline outranks inherited.
        An important declaration from inside the shadow root beats it, and keeps
        beating it however often the widget re-renders.

     2. we measure where the closed button actually lands and lift it by exactly
        what it overlaps. That one holds whatever they rename, and it is what
        recovers the placement when belt 1 stops matching their internals. */

  const CHAT_TAG = 'shopify-chat';

  const probe = document.createElement('div');
  probe.className = 'chat-clearance-probe';
  (document.body || document.documentElement).append(probe);

  const clearance = () => probe.getBoundingClientRect().height;

  /* The activator does not stay where it starts. On first load it is a button
     in the widget's own shadow root, but once the chat has been opened and
     closed again Shopify rebuilds it inside <shopify-agent-runtime>, which has
     a shadow root of its own: a querySelector on the outer root finds nothing
     from then on, and the button drops back onto the buy bar. So the search
     goes through the nested roots too.

     Closed state is read off the count rather than off a label, which would
     have to be guessed in five languages: closed, the widget shows exactly one
     button, the activator. Open, it shows a panel full of them, and then there
     is nothing to lift. */
  const visibleButtons = (root, found) => {
    for (const button of root.querySelectorAll('button')) {
      if (button.getBoundingClientRect().width > 0) found.push(button);
    }
    for (const el of root.querySelectorAll('*')) {
      if (el.shadowRoot) visibleButtons(el.shadowRoot, found);
    }
    return found;
  };

  const liftActivator = (shadowRoot) => {
    /* Closed state only. Once the chat is open the panel is meant to cover the
       screen, and the transform goes with the element it was written on. */
    const buttons = visibleButtons(shadowRoot, []);

    if (buttons.length !== 1) return;

    const button = buttons[0];

    /* measure the button, move its wrapper: the wrapper is the positioned box,
       while the button itself may carry the widget's own hover transform */
    const target = button.parentElement || button;

    target.style.removeProperty('transform');

    const overlap = button.getBoundingClientRect().bottom - (window.innerHeight - clearance());

    if (overlap > 0) {
      target.style.setProperty('transform', `translateY(${-overlap}px)`, 'important');
    }
  };

  let watching = false;

  const fitChatToTheme = () => {
    const shadowRoot = document.querySelector(CHAT_TAG)?.shadowRoot;

    if (!shadowRoot) return false;

    if (!watching) {
      watching = true;

      const style = document.createElement('style');
      style.textContent = '* { --shopify-agent-activator-offset: var(--chat-clearance) !important; }';
      shadowRoot.append(style);

      /* the widget rebuilds its insides while loading, on open and on close.
         Only childList is observed, so writing the transform back does not
         wake the observer up again.

         A mutation inside a nested shadow root does not reach an observer on
         the root above it, and the close rebuild happens inside
         <shopify-agent-runtime>'s own root: every root found has to be observed
         in its own right, or the button comes back without anyone noticing. */
      let queued = false;
      const watchedRoots = new WeakSet();
      const observer = new MutationObserver(() => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(remeasure);
      });

      function watchRoots(root) {
        if (!watchedRoots.has(root)) {
          watchedRoots.add(root);
          observer.observe(root, { childList: true, subtree: true });
        }
        for (const el of root.querySelectorAll('*')) {
          if (el.shadowRoot) watchRoots(el.shadowRoot);
        }
      }

      function remeasure() {
        queued = false;
        watchRoots(shadowRoot);
        liftActivator(shadowRoot);
      }

      watchRoots(shadowRoot);

      /* A root created during the rebuild has no observer on it yet, so the
         mutation that puts the button back can go unseen. The click that caused
         the rebuild is composed and does reach the document, and two passes
         cover it: one on the next frame, one after the widget has settled.
         ponytail: a fixed 400ms wait, not a state machine. If Shopify ever makes
         the reopen slower than that, listen for their own open/close event. */
      document.addEventListener(
        'click',
        () => {
          requestAnimationFrame(remeasure);
          setTimeout(remeasure, 400);
        },
        true
      );

      window.addEventListener('resize', remeasure);
      window.visualViewport?.addEventListener('resize', remeasure);
      /* the buy bar changes height when the price wraps onto a second line */
      document.addEventListener('theme:sticky-bar-resize', remeasure);
    }

    liftActivator(shadowRoot);

    return true;
  };

  const waitForChat = () => {
    if (fitChatToTheme()) return;

    /* the element can be defined a moment before it is in the document with a
       shadow root of its own */
    const poll = setInterval(() => {
      if (fitChatToTheme()) clearInterval(poll);
    }, 300);
    setTimeout(() => clearInterval(poll), 60000);
  };

  /* nothing runs at all on stores with the embed disabled: the promise never
     settles, so there is no polling to pay for */
  if (customElements.get(CHAT_TAG)) waitForChat();
  else customElements.whenDefined(CHAT_TAG).then(waitForChat);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collapsible-row"] && !Shopify.designMode) return;
  try {
    // Bursts oranges when a collapsible opens, and closes the sibling rows on
  // browsers without native `<details name>` exclusivity. The `toggle` event
  // does not bubble, so the listener runs in the capture phase.
  if (!window.collapsibleRowReady) {
    window.collapsibleRowReady = true;

    const supportsExclusive = 'name' in document.createElement('details');

    document.addEventListener(
      'toggle',
      (event) => {
        const row = event.target;
        if (!row.open || !row.hasAttribute?.('citrus-spill')) return;

        const group = row.getAttribute('name');
        if (!supportsExclusive && group) {
          document.querySelectorAll(`details[name="${group}"][open]`).forEach((other) => {
            if (other !== row) other.open = false;
          });
        }

        // burst from the row the visitor actually clicked
        const summary = row.querySelector('summary') || row;
        summary.dispatchEvent(new CustomEvent('citrus:spill', { bubbles: true }));
      },
      true
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-input"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('quantity-input')) {
    class QuantityInput extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input');
        this.querySelector('[name="minus"]').addEventListener('click', () => this.step(-1));
        this.querySelector('[name="plus"]').addEventListener('click', () => this.step(1));
      }

      step(delta) {
        const min = this.input.min === '' ? 0 : Number(this.input.min);
        const max = this.input.max === '' ? Infinity : Number(this.input.max);
        const next = Math.min(max, Math.max(min, Number(this.input.value || 0) + delta));
        this.input.value = next;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    customElements.define('quantity-input', QuantityInput);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["share-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('share-buttons')) {
    class ShareButtons extends HTMLElement {
      connectedCallback() {
        this.url = this.dataset.shareUrl;
        this.title = this.dataset.shareTitle;
        this.status = this.querySelector('[data-share-status]');

        const nativeButton = this.querySelector('[data-share-native]');
        const copyButton = this.querySelector('[data-share-copy]');

        if (navigator.share && nativeButton) {
          nativeButton.hidden = false;
          nativeButton.addEventListener('click', () => this.shareNative());
        }

        // Only the Facebook link goes away, and only on a touch device that has
        // the native sheet to replace it: the WhatsApp link opens its app from
        // the browser everywhere, so there is nothing to withdraw there.
        const facebookLink = this.querySelector('[data-share-facebook]');
        if (facebookLink && navigator.share && window.matchMedia('(pointer: coarse)').matches) {
          facebookLink.hidden = true;
        }

        if (navigator.clipboard && copyButton) {
          copyButton.hidden = false;
          copyButton.addEventListener('click', () => this.copyLink());
        }
      }

      async shareNative() {
        try {
          await navigator.share({ title: this.title, url: this.url });
        } catch (error) {
          // Dismissing the sheet rejects the promise; that is not a failure.
        }
      }

      async copyLink() {
        try {
          await navigator.clipboard.writeText(this.url);
          this.announce(this.dataset.copiedLabel);
        } catch (error) {
          // Clipboard writes can be denied by permissions; stay silent.
        }
      }

      announce(message) {
        if (!this.status) return;
        this.status.textContent = message;
        clearTimeout(this.resetTimer);
        this.resetTimer = setTimeout(() => {
          this.status.textContent = '';
        }, 4000);
      }
    }

    customElements.define('share-buttons', ShareButtons);
  }
  } catch(e) { console.error(e); }
})();

})();
